import { render, staticRenderFns } from "./EducationalGroupAttendanceForm.vue?vue&type=template&id=1ec2168e&"
import script from "./EducationalGroupAttendanceForm.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAttendanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports